<template>
  <v-row class="overview-item">
    <v-col cols="12">
      <div class="overview-item__title text-h6 text-sm-h5 font-weight-bold">
        Leituras
      </div>
    </v-col>
    <v-col>
      <v-card class="pa-12" style="height: 420px;">
        <line-chart :data="chart" :options="options" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type Overview from '@/types/Overview'
import type { OverviewReadingItem } from '@/types/Overview'
import { Line } from 'vue-chartjs'
import type { ChartData, ChartOptions } from 'chart.js'

export default defineComponent({
  components: {
    'line-chart': Line,
  },
  props: {
    overview: {
      type: Object as PropType<Overview>,
      required: true,
    },
  },
  computed: {
    items(): OverviewReadingItem[] {
      return this.overview.readings
    },
    chart(): ChartData<'line'> {
      return {
        labels: this.items.map(i => i.time.split(' ')[1]),
        datasets: [
          {
            label: 'Acessos',
            data: this.items.map(i => i.valid),
            backgroundColor: 'rgba(0,128,0,0.1)',
            borderColor: 'rgba(0,128,0,1)',
            fill: true,
          },
          {
            label: 'Ingresso Inexistente',
            data: this.items.map(i => i.invalid),
            backgroundColor: 'rgba(255,30,50,0.1)',
            borderColor: 'rgba(255,30,50,1)',
            fill: true,
          },
          {
            label: 'Leitura Duplicada',
            data: this.items.map(i => i.duplicate),
            backgroundColor: 'rgba(255,128,0,0.1)',
            borderColor: 'rgba(255,128,0,1)',
            fill: true,
          },
          {
            label: 'Setor Incorreto',
            data: this.items.map(i => i.wrong_section),
            backgroundColor: 'rgba(0,128,255,0.1)',
            borderColor: 'rgba(0,128,255,1)',
            fill: true,
          },
        ],
      }
    },
    options(): ChartOptions<'line'> {
      return {
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: 2,
      }
    },
  },
})
</script>
